import Account from "./views/account";
import Redirect from "./auth/Redirect";
import AuthGuard from "./auth/AuthGuard";
import NotFound from "./views/sessions/NotFound";
import sessionRoutes from "./views/sessions/session-routes";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import marketplaceRoutes from "./views/marketplace/marketplace-routes";
import appRoutes from "./views/app/app-routes";
import accountAppRoutes from "./views/account-app/account-app-routes";
import accountClientRoutes from "./views/account-client/account-client-routes";
import seatRoutes from "./views/seat/seat-routes";
import { Navigate } from "react-router-dom";
import homeRoutes from "./views/home/home-routes";
import sysadminMarketplaceRoutes from "./views/sysadmin/marketplace-app/sysadmin-marketplace-app-routes";
import sysadminAIAssistantTemplateRoutes from "./views/sysadmin/ai-assistant-template/sysadmin-ai-assistant-template-routes";
import welcomeRoutes from "./views/welcome/welcome-routes";
import aiAssistantRoutes from "./views/ai-assistant/ai-assistant-routes";
import billingRoutes from "./views/billing/billing-routes";
import subscriptionRoutes from "./views/subscriptions/subscription-routes";
import supportRoutes from "./views/support/support-routes";

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/", element: <Navigate to="/choose-account" /> },
      ...homeRoutes,
      ...marketplaceRoutes,
      ...appRoutes,
      ...accountAppRoutes,
      ...accountClientRoutes,
      ...seatRoutes,
      ...sysadminMarketplaceRoutes,
      ...sysadminAIAssistantTemplateRoutes,
      ...welcomeRoutes,
      ...aiAssistantRoutes,
      ...billingRoutes,
      ...subscriptionRoutes,
      ...supportRoutes,
      { path: "/account", element: <Account /> }
    ]
  },
  ...sessionRoutes,
  { path: "*", element: <NotFound /> }
];

export default routes;
